"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INDEXNOW_KEY_PATH = exports.INDEXNOW_KEY = void 0;
exports.INDEXNOW_KEY = 'b68a60d190e127a715c5dd4b99f2eecc';
exports.INDEXNOW_KEY_PATH = '/indexnow-key.txt';
